import React from "react";
// import placeholder from "../assets/Car place holder PNG.png";

const TwoCars = ({ heroSectionData }) => {
const palette = [
  { bg: "rgba(153, 163, 172, 0.9)", solid: "#99A3AC" }, // secondary / grey
  { bg: "rgba(19, 94, 159, 0.9)", solid: "#135E9F" },   // primary / blue
];


  return (
    <section className="py-6 bg-[#0b1224]">
      <div className="max-w-6xl ml-auto mr-0 px-4">
        <div className="relative flex flex-col items-center gap-8 md:gap-0">
          {heroSectionData.map((heroSection, index) => {
            const colors = palette[index % palette.length];
            const isFirst = index === 0;
            const isSecond = index === 1;
            // Positioning: green (first) sits lower, red (second) sits above overlapping mid-green
            const overlapClass = isFirst
              ? "md:self-start md:mt-10 md:z-10"
              : isSecond
              ? "md:-mt-28 md:ml-20 md:self-center md:z-30"
              : "md:mt-6";
            return (
              <div
                key={index}
                className={`relative rounded-3xl overflow-hidden h-[280px] sm:h-[300px] md:h-[320px] w-full md:w-[480px] shadow-[0_24px_60px_rgba(0,0,0,0.35)] transition-transform ${overlapClass}`}
              >
                {/* Background Image with color overlay */}
                <div
                  className="absolute inset-0 w-full h-full"
                  style={{
                    backgroundImage: `url(${heroSection?.image})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    filter: "saturate(0.9)",
                  }}
                />
                <div
                  className="absolute inset-0"
                  style={{
                    background: colors.bg,
                  }}
                />

                {/* Content */}
                <div className="relative z-10 h-full px-6 sm:px-8 md:px-10 flex items-center">
                  <div className="text-white max-w-md space-y-4 sm:space-y-5">
                    <h3 className="text-2xl sm:text-3xl md:text-4xl font-extrabold uppercase leading-tight">
                      {heroSection.title}
                    </h3>
                    <div
                      className="text-sm sm:text-base leading-relaxed text-white/90"
                      dangerouslySetInnerHTML={{
                        __html: heroSection?.description,
                      }}
                    />
                    <button
                      className="inline-flex items-center gap-2 px-4 py-2 sm:px-5 sm:py-2.5 bg-white text-[#0b1224] rounded-full text-sm sm:text-base font-semibold shadow hover:opacity-90 transition"
                      style={{ color: colors.solid }}
                    >
                      {heroSection.buttonText?.toUpperCase()}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="17"
                        height="18"
                        viewBox="0 0 17 18"
                        fill="none"
                      >
                        <path
                          d="M16.4315 0.529297H6.22589C5.96947 0.529297 5.76199 0.736786 5.76199 0.9932C5.76199 1.24961 5.96947 1.4571 6.22589 1.4571H15.3116L0.331228 16.4375C0.150007 16.6187 0.150007 16.9122 0.331228 17.0934C0.421817 17.184 0.540544 17.2293 0.659227 17.2293C0.77791 17.2293 0.896594 17.184 0.987226 17.0934L15.9676 2.11305V11.1988C15.9676 11.4552 16.175 11.6627 16.4315 11.6627C16.6879 11.6627 16.8954 11.4552 16.8954 11.1988V0.9932C16.8954 0.736786 16.6878 0.529297 16.4315 0.529297Z"
                          fill={colors.solid}
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TwoCars;